module.exports = __webpack_public_path__ + "img/product_26.817d5bc.jpg";